const formatMoney = (cents) =>
  (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

class UpsellProductList extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.product-upsell__item').forEach(item => this.initItem(item));
  }

  initItem(item) {
    const qtyDisplay = item.querySelector('[data-upsell-qty]');
    const minusBtn = item.querySelector('[data-upsell-qty-minus]');
    const plusBtn = item.querySelector('[data-upsell-qty-plus]');
    const addBtn = item.querySelector('[data-upsell-add-btn]');
    const variantSelect = item.querySelector('[data-upsell-variant-select]');

    let qty = 0;

    const updateQty = (newQty) => {
      qty = Math.max(0, newQty);
      qtyDisplay.textContent = qty;
      const isAdded = qty > 0;
      addBtn.setAttribute('aria-pressed', isAdded.toString());
      addBtn.classList.toggle('is-active', isAdded);
      item.classList.toggle('is-selected', isAdded);
      this.dispatchSelectionChange();
    };

    minusBtn.addEventListener('click', () => updateQty(qty - 1));
    plusBtn.addEventListener('click', () => {
      if (qty === 0) updateQty(1);
      else updateQty(qty + 1);
    });
    addBtn.addEventListener('click', () => {
      if (qty > 0) updateQty(0);
      else updateQty(1);
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        item.dataset.variantId = variantSelect.value;
        if (selectedOption?.dataset.price) {
          item.dataset.variantPrice = selectedOption.dataset.price;
          const price = Number(selectedOption.dataset.price);
          const comparePrice = Number(selectedOption.dataset.comparePrice || 0);
          const priceContainer = item.querySelector('.price');

          if (priceContainer) {
            const isOnSale = comparePrice > price;
            priceContainer.classList.toggle('price--on-sale', isOnSale);

            const saleEl = priceContainer.querySelector('.price__sale .price-item--sale');
            const regularEl = priceContainer.querySelector('.price__regular .price-item--regular');
            const compareEl = priceContainer.querySelector('.price__sale .price-item--regular');

            if (saleEl) saleEl.textContent = formatMoney(price);
            if (regularEl) regularEl.textContent = formatMoney(price);
            if (compareEl) compareEl.textContent = isOnSale ? formatMoney(comparePrice) : '';

            const percentBadge = priceContainer.querySelector('.badge:not(.price__badge-sale):not(.price__badge-sold-out)');
            const saleBadge = priceContainer.querySelector('.price__badge-sale');
            if (isOnSale) {
              if (percentBadge) {
                const pct = Math.round((comparePrice - price) * 100 / comparePrice);
                percentBadge.textContent = `-${pct}%`;
                percentBadge.style.display = '';
              }
              if (saleBadge) saleBadge.style.display = '';
            } else {
              if (percentBadge) percentBadge.style.display = 'none';
              if (saleBadge) saleBadge.style.display = 'none';
            }
          }
        }
        this.dispatchSelectionChange();
      });
    }

    item._getSelection = () => {
      if (qty === 0) return null;
      return {
        variantId: item.dataset.variantId,
        quantity: qty,
        price: Number(item.dataset.variantPrice || 0),
      };
    };
  }

  dispatchSelectionChange() {
    this.dispatchEvent(new CustomEvent('upsell:selection-change', { bubbles: true }));
  }

  getSelections() {
    return Array.from(this.querySelectorAll('.product-upsell__item'))
      .map(item => item._getSelection?.())
      .filter(Boolean);
  }
}

// Remove BSS Product Labels injected inside upsell items.
// Observe only upsell containers (not body) to avoid triggering on every DOM mutation.
// Disconnects automatically after 2 consecutive mutation cycles with no BSS badges found.
const upsellRoots = Array.from(document.querySelectorAll('upsell-product-list'));
if (upsellRoots.length > 0) {
  const removeBssLabels = () => {
    let found = 0;
    upsellRoots.forEach(root =>
      root.querySelectorAll('.product-upsell__item .bss_pl_img').forEach(el => { el.remove(); found++; })
    );
    return found;
  };
  removeBssLabels();
  let emptyRuns = 0;
  const bssObserver = new MutationObserver(() => {
    if (removeBssLabels() === 0) {
      emptyRuns++;
      if (emptyRuns >= 2) bssObserver.disconnect();
    } else {
      emptyRuns = 0;
    }
  });
  upsellRoots.forEach(root =>
    bssObserver.observe(root, { childList: true, subtree: true })
  );
}

window.getUpsellSelections = () =>
  Array.from(document.querySelectorAll('upsell-product-list'))
    .flatMap(list => list.getSelections());

customElements.define('upsell-product-list', UpsellProductList);

// ── Upsell Quickview ──
document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('[data-upsell-quickview-open]');
  if (!openBtn) return;
  const dialog = document.getElementById('upsell-quickview-' + openBtn.dataset.upsellQuickviewOpen);
  if (dialog) { dialog.showModal(); document.body.style.overflow = 'hidden'; }
});

document.querySelectorAll('dialog.upsell-quickview').forEach(dialog => {
  const mainImg = dialog.querySelector('.upsell-quickview__main-img');

  const closeDialog = () => { dialog.close(); document.body.style.overflow = ''; };

  dialog.querySelector('[data-upsell-quickview-close]')?.addEventListener('click', closeDialog);

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) closeDialog();
  });

  dialog.addEventListener('close', () => { document.body.style.overflow = ''; });

  dialog.querySelectorAll('[data-upsell-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (mainImg) { mainImg.srcset = ''; mainImg.src = thumb.dataset.src; }
      dialog.querySelectorAll('[data-upsell-thumb]')
        .forEach(t => t.classList.toggle('is-active', t === thumb));
    });
  });
});

// Show more logic
document.querySelectorAll('[data-upsell-show-more]').forEach(btn => {
  const list = btn.previousElementSibling;
  if (!list) return;
  const allItems = list.querySelectorAll('.product-upsell__item');
  const LIMIT = parseInt(btn.dataset.limit || '5', 10);
  let expanded = false;

  const collapse = () => {
    if (LIMIT === 0) {
      const firstItem = allItems[0];
      if (!firstItem) return;
      const listTop = list.getBoundingClientRect().top;
      const itemBottom = firstItem.getBoundingClientRect().bottom;
      list.style.maxHeight = (itemBottom - listTop) / 1.5 + 'px';
      list.classList.add('is-collapsed');
      return;
    }
    const fifthItem = allItems[LIMIT - 1];
    if (!fifthItem) return;
    const listTop = list.getBoundingClientRect().top;
    const itemBottom = fifthItem.getBoundingClientRect().bottom;
    const maxHeight = itemBottom - listTop + 50;
    list.style.maxHeight = maxHeight + 'px';
    list.classList.add('is-collapsed');
  };

  requestAnimationFrame(collapse);

  btn.addEventListener('click', () => {
    expanded = !expanded;
    if (expanded) {
      list.style.maxHeight = '';
      list.classList.remove('is-collapsed');
    } else {
      collapse();
    }
    const label = btn.querySelector('.product-upsell__show-more-label');
    const hiddenCount = allItems.length - LIMIT;
    label.textContent = expanded ? btn.dataset.labelLess : `${btn.dataset.labelMore} (${hiddenCount})`;
    btn.classList.toggle('is-expanded', expanded);
  });
});
